import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import handleMutationError from "app/utils/handleMutationError";
let OFFSET = 0;
let LIMIT = 10;

class BatchSummary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      limit: LIMIT,
      data: {},
      loading: false,
      offset: OFFSET,
      created_at_from: null,
      created_at_to: null
    };

    // FILTER
    this.filterFrom = this.filterFrom.bind(this);
    this.filterTo = this.filterTo.bind(this);

    // PAGINATION
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);

    // DATA LOAD
    this.loadBatch = this.loadBatch.bind(this);

    // MUTATION
    this.submitSettlementBatch = this.submitSettlementBatch.bind(this);
  }

  submitSettlementBatch(id: any) {
    this.props
      .submit_settlement_batch({
        variables: {
          id: id
        }
      })
      .then(({ data }) => {
        this.loadBatch(undefined, undefined, undefined);
      })
      .catch(handleMutationError);
  }

  componentDidMount() {
    this.loadBatch(this.state.created_at_from, this.state.created_at_to, 0);
    this.props.setHeader({
      title: `Settlement Batch ${this.props.match.params.id}`,
      description: "SnapScan Settlement Batch"
    });
  }

  loadBatch(createdAtFrom: any, createdAtTo: any, offset: any) {
    this.setState({
      data: {},
      loading: true,
      offset: offset,
      created_at_from: createdAtFrom,
      created_at_to: createdAtTo
    });

    this.props.batch_settlements.fetchMore({
      variables: {
        created_at_from: createdAtFrom,
        created_at_to: createdAtTo,
        offset: offset
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          data: fetchMoreResult.settlement_batches[0],
          loading: false
        });
      }
    });
  }

  goNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadBatch(
      this.state.created_at_from,
      this.state.created_at_to,
      TMP_OFFSET
    );
  }
  goPrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadBatch(
      this.state.created_at_from,
      this.state.created_at_to,
      TMP_OFFSET
    );
  }

  filterFrom(event: any, date: any) {
    this.loadBatch(date, this.state.created_at_to, 0);
  }
  filterTo(event: any, date: any) {
    this.loadBatch(this.state.created_at_from, date, 0);
  }

  render() {
    let batchDataList = this.state.data ? this.state.data : {};

    const statusButton = (status, id) => {
      if (status === "pending") {
        return (
          <button
            className="button statusButton"
            style={{
              marginRight: "10px",
              position: "absolute",
              right: "10px",
              top: "10px"
            }}
            onClick={() => this.submitSettlementBatch(id)}
          >
            Submit
          </button>
        );
      } else {
        return null;
      }
    };

    // Bank Settlements
    const settlements = () => {
      let returnVal = (
        <tr>
          <td colSpan={7} style={{ textAlign: "center" }}>
            None there
          </td>
        </tr>
      );
      if (
        batchDataList &&
        batchDataList.bank_settlements &&
        batchDataList.bank_settlements.length > 0
      ) {
        returnVal = batchDataList.bank_settlements.map((val, key) => {
          return (
            <tr key={key}>
              <td>{val.created_at}</td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/settlements/bank_settlements/${val.id}/summary`}
                >
                  {val.id}
                </Link>
              </td>
              <td>{val.status}</td>
              <td>{val.bank_name}</td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/merchants/${val.merchant.id}/payments`}
                >
                  {val.merchant.name}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={val.merchant.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
            </tr>
          );
        });
      }

      return returnVal;
    };

    const downloadValue = url => {
      if (url && url !== "") {
        return (
          <a
            className="blueLink"
            target="_blank"
            rel="noopener noreferrer"
            href={batchDataList.settlement_archive_url}
          >
            Download
          </a>
        );
      } else {
        return <i>No Value.</i>;
      }
    };

    return (
      <section
        id="Ops_PaymentsList"
        style={{ position: "relative" }}
        className="padded"
      >
        {statusButton(batchDataList.status, batchDataList.id)}
        <label>
          <b>Settlement Archive:</b>
          {downloadValue(batchDataList.settlement_archive_url)}
        </label>
        <br />
        <label>
          <b>Comment:</b> {batchDataList.comment}
        </label>
        <br />
        <label>
          <b>Status:</b> {batchDataList.status}
        </label>
        <h3
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            marginTop: "10px"
          }}
        >
          <span style={{ marginRight: "10px" }}>Bank Settlements: </span>
        </h3>
        <div
          id="setHeight"
          style={{
            height: "calc(100% - 90px)",
            overflow: "auto"
          }}
        >
          <table
            style={{
              width: "100%"
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>ID</th>
                <th>Status</th>
                <th>Bank</th>
                <th>Merchant</th>
              </tr>
            </thead>
            <tbody className={`${this.state.loading ? "hidden" : "shown"}`}>
              {settlements()}
            </tbody>
          </table>
        </div>
        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={() => this.goPrev()}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          className={
            (batchDataList &&
              batchDataList.bank_settlements &&
              batchDataList.bank_settlements.length < LIMIT) ||
            this.state.loading
              ? "hidden"
              : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={() => this.goNext()}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </section>
    );
  }
}

// QUERIES
const BankSettlementsofBatch = graphql(
  gql`
    query BankSettlementsofBatch(
      $offset: Int
      $limit: Int
      $created_at_from: String
      $created_at_to: String
      $id: ID
    ) {
      settlement_batches(id: $id) {
        id
        settlement_archive_url
        comment
        status
        bank_settlements(
          offset: $offset
          limit: $limit
          created_at_from: $created_at_from
          created_at_to: $created_at_to
        ) {
          created_at
          id
          bank_name
          status
          merchant {
            name
            id
            snapmin_url
          }
        }
      }
    }
  `,
  {
    name: "batch_settlements",
    options(props: any) {
      return {
        variables: {
          created_at_from: null,
          created_at_to: null,
          offset: OFFSET,
          limit: LIMIT,
          id: props.match.params.id
        }
      };
    }
  }
);
const releaseSettlement = graphql(
  gql`
    mutation releaseSettlement($id: ID!) {
      submit_settlement_batch(id: $id) {
        created_at
        id
      }
    }
  `,
  {
    name: "submit_settlement_batch"
  }
);

export default BankSettlementsofBatch(releaseSettlement(BatchSummary));
